module.exports = __webpack_public_path__ + "img/111.90acf312.jpg";